import {useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {
  deleteUserData,
  updateAdduserModal,
  updateAdduserModalData,
} from "../../../redux/Actions/users.action";

export const useUserTableAction = (fetchAfterDelete = () => {}) => {
  const dispatch = useDispatch();
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");

  const handleEdit = useCallback(
    (data) => {
      dispatch(updateAdduserModalData(data));
      dispatch(updateAdduserModal(true));
      setEditModalStatus(true);
    },
    [dispatch]
  );

  const handleDelete = (id) => {
    setDeleteModalStatus(true);
    setSelectedUserId(id);
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Edit":
        case "Change Password":
          setFormType(action);
          handleEdit(data);
          break;
        case "Delete":
          handleDelete(data.id);
          break;
      }
    },
    [handleEdit]
  );

  const deleteUser = () => {
    const callback = () => {
      setDeleteModalStatus(false);
      setSelectedUserId("");
      fetchAfterDelete();
    };
    dispatch(deleteUserData(selectedUserId, callback));
  };

  return {
    deleteModalStatus,
    deleteUser,
    editModalStatus,
    formType,
    handleActionSelection,
    selectedUserId,
    setDeleteModalStatus,
    setEditModalStatus,
  };
};
